"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UM = void 0;
exports.UM = {
    numericCode: '581',
    alpha2Code: 'UM',
    alpha3Code: 'UMI',
    englishName: {
        short: 'United States Minor Outlying Islands (the)',
        full: 'United States Minor Outlying Islands (the)',
    },
    names: {
        full: {
            en: 'United States Minor Outlying Islands (the)',
            fr: 'Îles mineures éloignées des États-Unis (les)',
        },
        short: {
            en: 'United States Minor Outlying Islands (the)',
            fr: 'Îles mineures éloignées des États-Unis (les)',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'UM-67': {
            numericCode: '581',
            code: 'UM-67',
            category: {
                id: '255',
                names: {
                    en: {
                        singular: 'islands, groups of islands',
                        plural: 'islands, groups of islands',
                    },
                    fr: {
                        singular: 'île, groupe d’îles',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Johnston Atoll',
            },
        },
        'UM-71': {
            numericCode: '581',
            code: 'UM-71',
            category: {
                id: '255',
                names: {
                    en: {
                        singular: 'islands, groups of islands',
                        plural: 'islands, groups of islands',
                    },
                    fr: {
                        singular: 'île, groupe d’îles',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Midway Islands',
            },
        },
        'UM-76': {
            numericCode: '581',
            code: 'UM-76',
            category: {
                id: '255',
                names: {
                    en: {
                        singular: 'islands, groups of islands',
                        plural: 'islands, groups of islands',
                    },
                    fr: {
                        singular: 'île, groupe d’îles',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Navassa Island',
            },
        },
        'UM-79': {
            numericCode: '581',
            code: 'UM-79',
            category: {
                id: '255',
                names: {
                    en: {
                        singular: 'islands, groups of islands',
                        plural: 'islands, groups of islands',
                    },
                    fr: {
                        singular: 'île, groupe d’îles',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Wake Island',
            },
        },
        'UM-81': {
            numericCode: '581',
            code: 'UM-81',
            category: {
                id: '255',
                names: {
                    en: {
                        singular: 'islands, groups of islands',
                        plural: 'islands, groups of islands',
                    },
                    fr: {
                        singular: 'île, groupe d’îles',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Baker Island',
            },
        },
        'UM-84': {
            numericCode: '581',
            code: 'UM-84',
            category: {
                id: '255',
                names: {
                    en: {
                        singular: 'islands, groups of islands',
                        plural: 'islands, groups of islands',
                    },
                    fr: {
                        singular: 'île, groupe d’îles',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Howland Island',
            },
        },
        'UM-86': {
            numericCode: '581',
            code: 'UM-86',
            category: {
                id: '255',
                names: {
                    en: {
                        singular: 'islands, groups of islands',
                        plural: 'islands, groups of islands',
                    },
                    fr: {
                        singular: 'île, groupe d’îles',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Jarvis Island',
            },
        },
        'UM-89': {
            numericCode: '581',
            code: 'UM-89',
            category: {
                id: '255',
                names: {
                    en: {
                        singular: 'islands, groups of islands',
                        plural: 'islands, groups of islands',
                    },
                    fr: {
                        singular: 'île, groupe d’îles',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kingman Reef',
            },
        },
        'UM-95': {
            numericCode: '581',
            code: 'UM-95',
            category: {
                id: '255',
                names: {
                    en: {
                        singular: 'islands, groups of islands',
                        plural: 'islands, groups of islands',
                    },
                    fr: {
                        singular: 'île, groupe d’îles',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Palmyra Atoll',
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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